import _ from 'lodash';
import flatten from 'flat';
import { sonnet } from './Sonnet/sonnet';
import { definity } from './Definity/definity';

export const themes = {
  sonnet: sonnet,
  definity: definity,
};

export const activateTheme = (theme) => {
  const variables = createVariables(theme);
  applyVariables(variables);
};

export const createVariables = (theme) => {
  const flattened = flatten(theme);
  return Object.entries(flattened).map(([p, v]) => ({
    property: _.kebabCase(p),
    value: v,
  }));
};

export const applyVariables = (variables) => {
  variables.forEach(({ property, value }) => {
    document.querySelector(':root').style.setProperty(`--${property}`, value);
  });
};
